<template>
  <div id="projects-detail">
    <div class="row">
      <div class="col-md-12">
        <ckeditor v-model="description" :editor="editor" :config="editorConfig" @ready="attachInspector"></ckeditor>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import inlineEditorConfig from '../mixins/InlineEditorConfig';
import helpers from '../helpers/helpers';

export default {
  mixins: [inlineEditorConfig],
  props: ['projectId', 'initialProjectDescription'],
  data() {
    return {};
  },
  computed: {
    description: {
      get() {
        return this.$store.state.projectEditor.projectDescription;
      },
      set(value) {
        this.commitUpdateProjectEditorDescriptionDebounced(value);
        EventBus.$emit('setIsSavedProject', false);
      },
    },
  },
  created() {
    this.initProjectEditor();
  },
  methods: {
    initProjectEditor() {
      this.$store.commit('createProjectDescription', this.initialProjectDescription);
    },

    commitUpdateProjectEditorDescriptionDebounced: _.debounce(function (value) {
      this.$store.commit('updateProjectEditorDescription', helpers.replaceSmartQuotes(value));
    }, 100),
  },
};
</script>
